// src/context/AuthContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';
// ASSUMPTION: 'auth' (Firebase Auth instance) is exported from '../firebase'
import { auth } from '../firebase'; 
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    onAuthStateChanged
} from 'firebase/auth';

// 1. Create the Context
const AuthContext = createContext();

// 2. Custom Hook to use the Context
export const useAuth = () => {
    return useContext(AuthContext);
};

// 3. Context Provider Component
export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true); // Initial loading state

    // --- Authentication Functions ---

    // Function to handle user sign up
    const signup = (email, password) => {
        return createUserWithEmailAndPassword(auth, email, password);
    };

    // Function to handle user sign in
    const login = (email, password) => {
        return signInWithEmailAndPassword(auth, email, password);
    };

    // Function to handle user sign out
    const logout = () => {
        return signOut(auth);
    };

    // --- Effect to Manage User State ---
    useEffect(() => {
        // Sets up a listener for changes in the user's sign-in status
        const unsubscribe = onAuthStateChanged(auth, user => {
            setCurrentUser(user);
            setLoading(false);
        });

        // Cleanup the listener when the component unmounts
        return unsubscribe;
    }, []);


    // The context value provides the current user and the auth methods
    const value = {
        currentUser,
        signup,
        login,
        logout
    };

    // We only render children once the initial user state is confirmed
    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};